// extracted by mini-css-extract-plugin
export default {"contentRight":"SharePostLayout_contentRight__63QSw","header":"SharePostLayout_header__wQN9n"};